mutation generatePixAPicInstructions(
  $code: String!
  $name: String!
  $email: String!
  $sourceImageKey: String!
  $numberOfKits: Int!
  $backgroundMaskImageKey: String
  $picture: GeneratepixapicinstructionsPicture!
) {
  generatePixAPicInstructions(
    code: $code
    name: $name
    email: $email
    picture: $picture
    numberOfKits: $numberOfKits
    sourceImageKey: $sourceImageKey
    backgroundMaskImageKey: $backgroundMaskImageKey
  )
}
